import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/reviews`, {params})
    },
    create(params) {
        return Vue.axios.post(`/reviews/create`, params)
    },
    remove(id) {
        return Vue.axios.get(`/reviews/remove/${id}`)
    },
    setProcessed(id) {
        return Vue.axios.get(`/reviews/set-processed/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/reviews/${id}`)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
